import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SavedSelection } from '../../models/land';

type LandType = 'save' | 'claim';

interface InitialState {
  isModalOpen: boolean;
  isSelectingLand: boolean;
  hasFinishedSelectingLand: boolean;
  hasFinishedEditingLand: boolean;
  isEditing: boolean;
  currentLandSelection: SavedSelection | null;
  editingLandType: 'save' | 'claim' | null;
}

interface IEditingLandSelectionsPayload {
  isEditing: boolean;
  data: SavedSelection;
}

const initialState: InitialState = {
  currentLandSelection: null,
  editingLandType: null,
  hasFinishedEditingLand: false,
  hasFinishedSelectingLand: false,
  isEditing: false,
  isModalOpen: false,
  isSelectingLand: false,
};

const landSelectionsSlice = createSlice({
  initialState,
  name: 'land-selections',
  reducers: {
    clearCurrentLandSelection: (state) => {
      // state.currentClaim = initialState.currentClaim;
      state.hasFinishedEditingLand = initialState.hasFinishedEditingLand;
    },
    clearLandSelection: (state) => {
      state.isSelectingLand = initialState.isSelectingLand;
      state.hasFinishedSelectingLand = initialState.hasFinishedSelectingLand;
      state.hasFinishedEditingLand = initialState.hasFinishedEditingLand;
      state.isModalOpen = initialState.isModalOpen;
      state.isEditing = initialState.isEditing;
      state.editingLandType = initialState.editingLandType;
    },
    setCurrentLandSelection: (
      state,
      action: PayloadAction<SavedSelection | null>
    ) => {
      state.currentLandSelection = action.payload;
    },
    setEditingLandType: (state, action: PayloadAction<LandType>) => {
      state.editingLandType = action.payload;
    },
    setHasFinishedEditingLandSelections: (state) => {
      state.hasFinishedEditingLand = true;
      state.isEditing = false;
      state.isModalOpen = false;
    },
    setHasFinishedSelectingLand: (state) => {
      state.hasFinishedSelectingLand = true;
      state.isSelectingLand = false;
      state.isModalOpen = true;
    },
    setIsEditingLand: (
      state,
      action: PayloadAction<IEditingLandSelectionsPayload>
    ) => {
      state.isEditing = action.payload.isEditing;
      state.currentLandSelection = action.payload.data;
      state.isModalOpen = false;
    },
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
      state.isSelectingLand = false;
    },
    setIsSelectingLand: (state, action: PayloadAction<boolean>) => {
      state.isSelectingLand = action.payload;
      state.isModalOpen = false;
    },
  },
});

export const {
  clearCurrentLandSelection,
  clearLandSelection,
  setHasFinishedSelectingLand,
  setIsModalOpen,
  setIsSelectingLand,
  setHasFinishedEditingLandSelections,
  setIsEditingLand,
  setEditingLandType,
  setCurrentLandSelection,
} = landSelectionsSlice.actions;

export default landSelectionsSlice.reducer;
